<template>
  <div :class="$b()">
    <div :class="$b('heading')">
      {{ heading }}
    </div>
    <div :class="$b('subheading')">
      {{ subheading }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogStack',
  props: {
    heading: {
      type: String,
      default: ''
    },
    subheading: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="postcss">
.DialogStack {
  @apply inline-flex flex-col
    text-off-black
    mt-xxs;
  
  + .DialogStack {
    @apply ml-sm pl-xs lg:ml-xl xl:ml-xxl;
  }
}

.DialogStack__heading {
  @apply text-3xl md:text-4xl font-semibold leading-none
    pt-sm md:pt-xxs;
}

.DialogStack__subheading {
  @apply text-xxs md:text-xs
    max-w-[125px];
}
</style>